import * as React from 'react';

export const queryElementBy = (elementSelector: string | HTMLElement | Window) => {
  if (typeof elementSelector === 'string') {
    return document.querySelector(elementSelector as string);
  }
  return elementSelector;
};

export const useElementQuerySelector = (scrollContainerElm: string | HTMLElement | Window) => {
  const elementRef = React.useRef(null);
  React.useEffect(() => {
    elementRef.current = queryElementBy(scrollContainerElm);
  }, [scrollContainerElm]);

  return { elementRef };
};
